export enum ChipTheme {
  DEFAULT = 'default',
  ACTIVE = 'active',
  SUSTAINABILITY = 'sustainability',
}
